
const goodsReview = {
    path: 'goods_review',
    component: resolve => require(['@/pages/admin/aftersales/goodsReview/index.vue'], resolve),
    meta: {
        requireAuth: true
    },
    children: [

    ]
}

export default goodsReview